/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';
import type { TypeAsset } from '/stores/AssetStore';
import type TypeForm from 'forms/_.extend';

import Loading from 'components/Loading/Loading';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import styles from '../../../../ActionDrawer.module.scss';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

type TypeProps = {
  asset: Object,
  form: TypeForm,
};

type InjectedProps = {
  assetStore: TypeAsset,
} & TranslatorProps;

@translate()
@inject('assetStore')
@observer
export default class UnassignAssetForm extends ComponentWithInjectedProps<
  TypeProps,
  {},
  InjectedProps
> {
  render(): React.Fragment {
    const { t, asset, form, assetStore }: TypeProps = this.props;

    const assetDetails: Object = asset.account ? asset : assetStore.asset;

    const assetInfo: Array<*> = [
      [
        t('general:trading_account'),
        assetDetails.account && `${assetDetails.account.name} ${assetDetails.account.number}`,
      ],
      [t('general:assets.labels.number'), assetDetails.asset_number],
      [t('general:manufacturer'), assetDetails.manufacturer],
      [t('general:model'), assetDetails.model],
      [t('general:labels.serial_number'), assetDetails.serial_number],
    ];

    if (!assetStore.asset.account) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={assetInfo} />
          </ActionDrawerBlock>
          {assetDetails.user && assetDetails.user.name && (
            <ActionDrawerBlock
              divider={true}
              gutters={true}
              heading={t('general:assets.currently_assigned_to')}
            >
              <ul>
                <li>{assetDetails.user.name}</li>
                <li>{`${t('general:roles.labels.current_role')}: ${assetDetails.user.role}`}</li>
              </ul>
            </ActionDrawerBlock>
          )}
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.unassign_asset')} />
      </React.Fragment>
    );
  }
}
